import { Base } from '@or-sdk/base';
import { Settings, Agents, RuleGroups, ContactRuleGroups, EventTemplates, Conferences, Filters, CannedMessages, Sessions, SessionEvents, Listeners, Commands, ContactsMeta, Helpers, Versions, Tasks, SessionRelations, Contacts, } from './api';
import { AppError } from './AppError';
import { EKS } from './EKS';
import { SERVICE_KEY } from './constants';
export class HITL extends Base {
    constructor(params) {
        super({
            token: params.token,
            discoveryUrl: params.discoveryUrl,
            serviceKey: SERVICE_KEY,
            accountId: params.accountId,
            serviceUrl: params.hitlUrl,
        });
        const expressAPI = new EKS(params);
        const request = this.callApiV2.bind(this);
        this.migrations = expressAPI.migrations;
        this.settings = Settings.configure(request);
        this.agents = Agents.configure(request);
        this.ruleGroups = RuleGroups.configure(request);
        this.contactRuleGroups = ContactRuleGroups.configure(request);
        this.eventTemplates = EventTemplates.configure(request);
        this.conferences = Conferences.configure(request);
        this.filters = Filters.configure(request);
        this.cannedMessages = CannedMessages.configure(request);
        this.sessions = Sessions.configure(request);
        this.sessionEvents = SessionEvents.configure(request);
        this.listeners = Listeners.configure(request);
        this.commands = Commands.configure(request);
        this.contactsMeta = ContactsMeta.configure(request);
        this.helpers = Helpers.configure(request);
        this.versions = Versions.configure(request);
        this.tasks = Tasks.configure(request);
        this.sessionRelations = SessionRelations.configure(request);
        this.contacts = Contacts.configure(request);
    }
    parseError(e) {
        var _a;
        return new AppError((_a = e.response) === null || _a === void 0 ? void 0 : _a.data);
    }
}
export { AppError };
//# sourceMappingURL=HITL.js.map